import { conf } from '../config/config';

const fantasyEndpoint = `${conf.endpoint.replace(/\/$/, '')}/api/fantasy`;

export async function submitFantasy(payload) {
    const response = await fetch(fantasyEndpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(result.error?.message || 'We could not submit your fantasy request. Please try again.');
    }

    return result.data;
}
